import { GutEvaluationMeaning } from 'types/GutType';
import { brandPalette } from '@repo/utils';

export const getColorFromGutVaginalEvaluationMeaning = (
  meaning: GutEvaluationMeaning,
) => {
  let color;
  switch (meaning) {
    case 'borderline':
      color = brandPalette.orange['500a'];
      break;
    case 'clear':
      color = brandPalette.green['700a'];
      break;
    case 'flag':
      color = brandPalette.red['500a'];
      break;
    default:
      color = brandPalette.purple[500];
      break;
  }
  return color;
};
